import React from 'react';

import { Box } from '@material-ui/core';

import Slide from '@material-ui/core/Slide';

import styled from 'styled-components';
import cookies from 'js-cookie';
import { LinkTracker } from '@www/components/LinkTracker';
import { IMBButtonHoverVariant, MBButton } from '@meetbutter/ui';

const Title = styled.div`
  font-family: Inter;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  padding-bottom: 8px;
`;

const Text = styled.div`
  font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;

  padding-bottom: 16px;
`;
const Container = styled.div`
  position: fixed;
  left: 12px;
  bottom: 30px;
  z-index: 200;
`;

export const CookieBanner = () => {
  const [drawer, setDrawer] = React.useState(false);

  const handleClose = () => {
    setDrawer(false);
    cookies.set('cookiePolicy', true, { expires: 30 });
  };
  const handleOpen = () => {
    setDrawer(true);
  };

  const cookieValidation = async () => {
    const cookiePolicy = await cookies.get('cookiePolicy');

    if (!cookiePolicy) {
      handleOpen();
    }
  };

  React.useEffect(() => {
    cookieValidation();
  }, []);

  return (
    <Slide in={drawer} timeout={500} direction={'right'}>
      <Container>
        <Box maxWidth={350}>
          <Box
            maxWidth={650}
            margin="0 auto"
            p={4}
            bgcolor="#fff"
            boxShadow="10px 10px 0px 0 #000"
          >
            <Title>
              Butter cookies{' '}
              <span role="img" aria-label="cookie">
                🍪
              </span>
            </Title>
            <Text>
              To give you a buttery smooth experience, we use cookies. By
              continuing to use the site you agree to our{' '}
              <LinkTracker
                variant="classic"
                href="/cookie-policy"
                onClick={handleClose}
              >
                {' '}
                use of cookies.
              </LinkTracker>
            </Text>
            <MBButton
              fullWidth
              padding="16px 20px"
              hoverVariant={IMBButtonHoverVariant.darken}
              onClick={handleClose}
            >
              I agree
            </MBButton>
          </Box>
        </Box>
      </Container>
    </Slide>
  );
};
